import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment';

import PeriodPicker from '../../components/PeriodPicker';
export const SERIALIZATION_FORMAT = 'YYYY-MM-DD';

const serializeDate = (maybeDate) => maybeDate ? moment(maybeDate).format(SERIALIZATION_FORMAT) : '';

export default class BoundPeriodPicker extends PureComponent {
  static propTypes = {
    disabledDays: PropTypes.array,
  }

  constructor(props) {
    super(props);
    const {
      dateFrom: { input: { value: fromValue } },
      dateTo: { input: { value: toValue } }
    } = props;
    this.state = {
      fromDate: fromValue? moment(fromValue, SERIALIZATION_FORMAT).toDate() : null,
      toDate: toValue? moment(toValue, SERIALIZATION_FORMAT).toDate() : null,
    }

    this.onFromChange = this.onFromChange.bind(this);
    this.onToChange = this.onToChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const {
      dateFrom: { input: { value: oldFromValue } },
      dateTo: { input: { value: oldToValue } }
    } = this.props;

    const {
      dateFrom: { input: { value: newFromValue } },
      dateTo: { input: { value: newToValue } }
    } = nextProps;

    if (oldFromValue !== newFromValue || oldToValue !== newToValue) {
      this.setState({
        fromDate: newFromValue? moment(newFromValue, SERIALIZATION_FORMAT).toDate() : null,
        toDate: newToValue? moment(newToValue, SERIALIZATION_FORMAT).toDate() : null,
      });
    }
  }

  onFromChange(maybeDate) {
    const { dateFrom: { input: { onChange } } } = this.props;
    onChange(serializeDate(maybeDate));
  }

  onToChange(maybeDate) {
    const { dateTo: { input: { onChange } } } = this.props;
    onChange(serializeDate(maybeDate));
  }

  render() {
    const { disabledDays } = this.props;
    return (
      <PeriodPicker
        {...this.state}
        disabledDays={disabledDays}
        onFromChange={this.onFromChange}
        onToChange={this.onToChange}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/ProductBasket/BoundPeriodPicker.js